
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $7Tdq9 = parcelRequire("7Tdq9");
const $5f3eb351270a13c9$var$STORAGE_KEY = "khromatik_cookie_consent";
const $5f3eb351270a13c9$var$CONSENT_VERSION = 1;
const $5f3eb351270a13c9$var$GA_MEASUREMENT_ID = "G-0LV6HK0X2B";
const $5f3eb351270a13c9$var$CLARITY_ID = "w61ru1fkg6";
let $5f3eb351270a13c9$var$analyticsInjected = false;
function $5f3eb351270a13c9$export$16ec282473a629c4() {
    return /\/projects\//.test(location.pathname) ? "../" : "./";
}
function $5f3eb351270a13c9$var$parseConsent() {
    try {
        const raw = localStorage.getItem($5f3eb351270a13c9$var$STORAGE_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (data.v !== $5f3eb351270a13c9$var$CONSENT_VERSION) return null;
        if (typeof data.analytics !== "boolean") return null;
        return data;
    } catch  {
        return null;
    }
}
function $5f3eb351270a13c9$var$saveConsent(analytics) {
    const payload = {
        v: $5f3eb351270a13c9$var$CONSENT_VERSION,
        analytics: analytics,
        savedAt: new Date().toISOString()
    };
    localStorage.setItem($5f3eb351270a13c9$var$STORAGE_KEY, JSON.stringify(payload));
}
function $5f3eb351270a13c9$var$updateGtagConsent(granted) {
    if (typeof window.gtag !== "function") return;
    window.gtag("consent", "update", {
        analytics_storage: granted ? "granted" : "denied",
        ad_storage: granted ? "granted" : "denied",
        ad_user_data: granted ? "granted" : "denied",
        ad_personalization: granted ? "granted" : "denied"
    });
}
function $5f3eb351270a13c9$var$injectClarity() {
    if (window.clarity) return;
    (function(c, l, a, r, i, t, y) {
        c[a] = c[a] || function() {
            (c[a].q = c[a].q || []).push(arguments);
        };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", $5f3eb351270a13c9$var$CLARITY_ID);
}
function $5f3eb351270a13c9$var$injectGa() {
    if ($5f3eb351270a13c9$var$analyticsInjected) return;
    $5f3eb351270a13c9$var$analyticsInjected = true;
    const gtagScript = document.createElement("script");
    gtagScript.async = true;
    gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=" + $5f3eb351270a13c9$var$GA_MEASUREMENT_ID;
    document.head.appendChild(gtagScript);
    window.gtag("js", new Date());
    window.gtag("config", $5f3eb351270a13c9$var$GA_MEASUREMENT_ID);
    $5f3eb351270a13c9$var$injectClarity();
}
function $5f3eb351270a13c9$export$f43a0316c577d091() {
    const consent = $5f3eb351270a13c9$var$parseConsent();
    if (consent?.analytics) {
        $5f3eb351270a13c9$var$updateGtagConsent(true);
        $5f3eb351270a13c9$var$injectGa();
    }
    return consent;
}
function $5f3eb351270a13c9$var$wirePolicyLink() {
    const el = document.getElementById("cookie-banner-policy");
    if (el) el.href = `${$5f3eb351270a13c9$export$16ec282473a629c4()}impressum.html#cookies`;
}
function $5f3eb351270a13c9$var$getBannerEls() {
    const root = document.getElementById("cookie-consent-banner");
    if (!root) return null;
    return {
        root: root,
        accept: document.getElementById("cookie-consent-accept"),
        reject: document.getElementById("cookie-consent-reject")
    };
}
function $5f3eb351270a13c9$var$showBanner() {
    const els = $5f3eb351270a13c9$var$getBannerEls();
    if (!els) return;
    els.root.hidden = false;
    els.root.setAttribute("aria-hidden", "false");
}
function $5f3eb351270a13c9$var$hideBanner() {
    const els = $5f3eb351270a13c9$var$getBannerEls();
    if (!els) return;
    els.root.hidden = true;
    els.root.setAttribute("aria-hidden", "true");
}
function $5f3eb351270a13c9$var$onAccept() {
    $5f3eb351270a13c9$var$saveConsent(true);
    $5f3eb351270a13c9$var$updateGtagConsent(true);
    $5f3eb351270a13c9$var$injectGa();
    $5f3eb351270a13c9$var$hideBanner();
}
function $5f3eb351270a13c9$var$onReject() {
    $5f3eb351270a13c9$var$saveConsent(false);
    $5f3eb351270a13c9$var$updateGtagConsent(false);
    $5f3eb351270a13c9$var$hideBanner();
}
function $5f3eb351270a13c9$var$wireBanner() {
    const els = $5f3eb351270a13c9$var$getBannerEls();
    if (!els) return;
    els.accept?.addEventListener("click", $5f3eb351270a13c9$var$onAccept);
    els.reject?.addEventListener("click", $5f3eb351270a13c9$var$onReject);
}
function $5f3eb351270a13c9$var$wireFooterTrigger() {
    const btn = document.getElementById("cookie-settings-trigger");
    if (!btn) return;
    btn.addEventListener("click", ()=>$5f3eb351270a13c9$var$showBanner());
}
function $5f3eb351270a13c9$export$ebe49a19daeb1dbf() {
    $5f3eb351270a13c9$var$showBanner();
}
function $5f3eb351270a13c9$export$aa2e2863d5778f13() {
    if (typeof window.gtag !== "function") {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
            window.dataLayer.push(arguments);
        };
        window.gtag("consent", "default", {
            analytics_storage: "denied",
            ad_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
            wait_for_update: 500
        });
    }
    $5f3eb351270a13c9$var$wirePolicyLink();
    $5f3eb351270a13c9$var$wireBanner();
    $5f3eb351270a13c9$var$wireFooterTrigger();
    const consent = $5f3eb351270a13c9$var$parseConsent();
    if (consent === null) $5f3eb351270a13c9$var$showBanner();
    else if (consent.analytics) {
        $5f3eb351270a13c9$var$updateGtagConsent(true);
        $5f3eb351270a13c9$var$injectGa();
    }
}
window.openCookiePreferences = $5f3eb351270a13c9$export$ebe49a19daeb1dbf;



var $7Tdq9 = parcelRequire("7Tdq9");
/** WhatsApp number in international format without +, spaces, or leading 0 (e.g. 40722123456) */ const $58aaf020a3373c7f$export$c0b849650430425a = "40757162237";


function $bf06efc57b5c33aa$var$getCurrentLanguage() {
    return localStorage.getItem("language") || "ro";
}
function $bf06efc57b5c33aa$var$getWhatsAppStrings(lang) {
    return (0, $7Tdq9.translations)[lang]?.common?.whatsapp || (0, $7Tdq9.translations).en.common.whatsapp;
}
function $bf06efc57b5c33aa$var$buildWhatsAppUrl(lang) {
    const { prefill: prefill } = $bf06efc57b5c33aa$var$getWhatsAppStrings(lang);
    return `https://wa.me/${0, $58aaf020a3373c7f$export$c0b849650430425a}?text=${encodeURIComponent(prefill)}`;
}
function $bf06efc57b5c33aa$var$updateWhatsAppLinks() {
    const lang = $bf06efc57b5c33aa$var$getCurrentLanguage();
    const { label: label } = $bf06efc57b5c33aa$var$getWhatsAppStrings(lang);
    const url = $bf06efc57b5c33aa$var$buildWhatsAppUrl(lang);
    document.querySelectorAll("[data-whatsapp-link]").forEach((link)=>{
        link.href = url;
        link.setAttribute("aria-label", label);
        link.setAttribute("title", label);
    });
}
function $bf06efc57b5c33aa$export$99e5bd9db37d8d6e() {
    $bf06efc57b5c33aa$var$updateWhatsAppLinks();
    document.addEventListener("languageChanged", $bf06efc57b5c33aa$var$updateWhatsAppLinks);
}


class $9e30b5b5de697b16$var$I18n {
    constructor(){
        const storedLanguage = localStorage.getItem("language");
        if (storedLanguage) this.currentLanguage = storedLanguage;
        else {
            this.currentLanguage = this.detectSystemLanguage();
            // Store the detected language for consistency
            localStorage.setItem("language", this.currentLanguage);
        }
        this.translations = {};
        this.init();
    }
    detectSystemLanguage() {
        const supportedLanguages = [
            "en",
            "de",
            "ro"
        ];
        let browserLanguage = null;
        // Try to get language from navigator.languages (preferred) or navigator.language
        if (navigator.languages && navigator.languages.length > 0) browserLanguage = navigator.languages[0];
        else if (navigator.language) browserLanguage = navigator.language;
        if (browserLanguage) {
            // Extract language code (e.g., "ro-RO" → "ro", "en-US" → "en")
            const languageCode = browserLanguage.split("-")[0].toLowerCase();
            // Check if the language is supported
            if (supportedLanguages.includes(languageCode)) return languageCode;
        }
        // Default to Romanian if no supported language is detected
        return "ro";
    }
    async init() {
        await this.loadTranslations();
        this.translatePage();
        this.updateHtmlLang();
        this.initializeLanguageSelector();
        (0, $5f3eb351270a13c9$export$aa2e2863d5778f13)();
        (0, $bf06efc57b5c33aa$export$99e5bd9db37d8d6e)();
    }
    async loadTranslations() {
        try {
            if (!(0, $7Tdq9.translations)[this.currentLanguage]) {
                console.error(`Translations not found for language: ${this.currentLanguage}`);
                console.log("Available languages:", Object.keys((0, $7Tdq9.translations)));
                // Fallback to English if language not found
                this.currentLanguage = "en";
                this.translations = (0, $7Tdq9.translations)[this.currentLanguage];
            } else this.translations = (0, $7Tdq9.translations)[this.currentLanguage];
        } catch (error) {
            console.error("Error loading translations:", error);
            // Fallback to English on error
            this.currentLanguage = "en";
            this.translations = (0, $7Tdq9.translations)[this.currentLanguage];
        }
    }
    translatePage() {
        const elements = document.querySelectorAll("[data-i18n]");
        elements.forEach((element)=>{
            const key = element.getAttribute("data-i18n");
            const [namespace, ...pathParts] = key.split(".");
            const path = pathParts.join(".");
            const namespaceTranslations = this.translations[namespace];
            const translation = this.getNestedTranslation(namespaceTranslations, path);
            if (translation) {
                if (element.tagName === "META") element.setAttribute("content", translation);
                else if (element.classList.contains("scramble-text")) {
                    element.textContent = translation;
                    if (window.initScrambleText) window.initScrambleText();
                } else element.textContent = translation;
            }
        });
    }
    getNestedTranslation(obj, path) {
        if (!obj || !path) return undefined;
        return path.split(".").reduce((p, c)=>p && typeof p === "object" ? p[c] : undefined, obj);
    }
    updateHtmlLang() {
        document.documentElement.lang = this.currentLanguage;
    }
    initializeLanguageSelector() {
        const selector = document.getElementById("languageSelect");
        if (selector) selector.value = this.currentLanguage;
    }
    async changeLanguage(lang) {
        this.currentLanguage = lang;
        localStorage.setItem("language", lang);
        await this.loadTranslations();
        this.translatePage();
        this.updateHtmlLang();
        // Dispatch language change event
        document.dispatchEvent(new Event("languageChanged"));
    }
}
const $9e30b5b5de697b16$var$i18n = new $9e30b5b5de697b16$var$I18n();
window.changeLanguage = async (lang)=>await $9e30b5b5de697b16$var$i18n.changeLanguage(lang);


//# sourceMappingURL=about.a3e31370.js.map
